module.exports = "/_next/static/images/BoxVideoCoverImage-0087f18e168c89f03b7a1031eb989ba2.png";